export default {
  BUY: 'Buy',
  SELL: 'Sell',
  NEU: 'Neutral',
  HOLD: 'Hold',
  NOCMT: 'No Recommendation',

  stackBarChartTooltipBUY: 'Buy: %{percent}%',
  stackBarChartTooltipSELL: 'Sell: %{percent}%',
  stackBarChartTooltipNEU: 'Neutral: %{percent}%',
  stackBarChartTooltipHOLD: 'Hold: %{percent}%',
  stackBarChartTooltipNOCMT: 'No Recommendation: %{percent}%',
  targetPriceChange: '%{change}% Downside',
  highest: 'Highest',
  average: 'Average',
  lowest: 'Lowest',

  targetPrice: 'Target Price',
  actualPrice: 'Actual Price',
  numOfRating: 'Number of Ratings',

  consensusHistory: 'CONSENSUS HISTORY',
  targetPriceTitle: 'CONSENSUS TARGET PRICE',

  downside: '%{percent}% Downside',
  upside: '%{percent}% Upside',

  notice:
    '*Disclaimer: FiinGroup will not accept any liability for loss or damage as a result of reliance on the information provided above. Please be fully informed that the number is subject to calculation during the past 3 months, so the predicted number may not be accurate and should be considered for reference purpose only. FiinGroup does not bear any responsibility for any losses you might incur as a result of using this data.',

  recommendationTitle: 'RECOMMENDATION',

  lastestRecommendation: 'Lastest Recommendation: ',

  price: 'Price',

  recommendationHistoryTitle: 'Percentage of Recommendations',

  sell: 'Sell',
  underweight: 'Underweight',
  hold: 'Hold',
  overweight: 'Overweight',
  buy: 'Buy',
  noRecommendation: 'No Recommendation',
  neutral: 'Neutral',
};
